import angular from 'angular';

export function CreativesTextBlocksComponent() {
  return {
    restrict: 'E',
    scope: {
      textBlocks: '='
    },
    controllerAs: 'vm',
    bindToController: true,
    controller: class {
      constructor() {}
    }
  }
};

export function setupTextblock({x,y,width}){
  return {
    text: '',
    align: 'center',
    font: {
      family: 'Arial',
      size: 12,
      color: '#000000',
      rotate: 0,
      letterSpacing: 0,
      lineHeight: 1,
      bold: true,
      italic: false,
      underline: false,
      wordWrap: true
    },
    position: {
      x,
      y,
      width
    }
  }
};

export function buildCreativeDefinition(assetSize) {
  let [width, height] = assetSize.split('x').map(str => parseInt(str));
  let padding = 5;
  let size = 12;

  return {
    lines: [
      setupTextblock({y: padding, x: padding, width: width-2*padding}),
      setupTextblock({y: (height/2)-padding-(size/2), x: padding, width: width-2*padding})
    ]
  };
}

export function cloneLine(creative, index) {
  let newLine = _.merge({},creative.definition.lines[index],{editing: false});
  newLine.position.y = newLine.position.y + Math.round((newLine.font.lineHeight + 0.2) * newLine.font.size);
  creative.definition.lines.splice(index, 0, newLine);
}

export function copyCreativeDefinition(fromCreative={}, toCreative) {
  if (!fromCreative.definition || fromCreative == toCreative)
    return;

  toCreative.definition = _.cloneDeep(fromCreative.definition);

  let [width, height] = toCreative.size.split('x').map(str => parseInt(str));
  let padding = 5;
  _.sortBy(toCreative.definition.lines, 'position.y').forEach((line, index) => {
    let newOffset = ((height/(toCreative.definition.lines.length-1))*index)-padding-line.font.size;
    line.position.y = newOffset || padding;
    if (line.position.y < padding)
      line.position.y = padding;
    line.position.x = padding;
    line.position.width = width-2*padding;
  });

  // fix live preview
  let customize = toCreative.customize == true;
  if (customize) {
    toCreative.customize = false;
    setTimeout(() => toCreative.customize = customize);
  }
}

export class CreativesTextBlockController {
  constructor(){}

  set editing(value) {
    this.textBlocksCtrl.textBlocks.forEach((l) => l.editing = false);
    this.textBlock.editing = value;
  }
  
  get editing() {
    return this.textBlock.editing;
  }

  get style() {
    return {
      color: this.textBlock.font.color,
      'font-family': this.textBlock.font.family,
      'font-size': this.textBlock.font.size+'px',
      'text-align': this.textBlock.align,
      'font-weight': this.textBlock.font.bold ? 'bold' : undefined,
      'letter-spacing': this.textBlock.font.letterSpacing+'px',
      'line-height': this.textBlock.font.lineHeight,
      '-webkit-transform': `rotate(${this.textBlock.font.rotate}deg)`,
      '-moz-transform': `rotate(${this.textBlock.font.rotate}deg)`,
      '-ms-transform': `rotate(${this.textBlock.font.rotate}deg)`,
      '-o-transform': `rotate(${this.textBlock.font.rotate}deg)`,
      'font-style': this.textBlock.font.italic ? 'italic' : undefined,
      'text-decoration': this.textBlock.font.underline ? 'underline' : undefined
    }
  }

  get textBlockStyle() {
    let lineHeight = this.textBlock.font.lineHeight;
    let fontSize = this.textBlock.font.size;
    let offset = Math.floor((lineHeight*fontSize-fontSize)/2);

    return {
      'opacity': 0,
      'margin-top': offset*(-1)+'px',
      'margin-bottom': offset*(-1)+'px'
    }
  }
};

export function CreativesTextBlockComponent() {
  return {
    template: `
			<div class='c-text-block' ng-style="vm.style" ng-class="{'is-active': vm.editing}">
        <div class='c-text-block__text' ng-style="vm.textBlockStyle" ng-keypress="vm.onKeypress($event)">{{ vm.textBlock.text }}</div>
			</div>
	  `,
    restrict: 'E',
    replace: true,
    require: '^creativesTextBlocks',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      textBlock: '='
    },
    controller: CreativesTextBlockController,
    link: function(scope, element, attrs, creativesTextBlocksCtrl) {
      scope.vm.textBlocksCtrl = creativesTextBlocksCtrl;

      scope.$watch('vm.textBlock.position',() => {
        element.css({
          top: scope.vm.textBlock.position.y - 4, // 4px border+text padding
          left: scope.vm.textBlock.position.x,
          width: scope.vm.textBlock.position.width
        });
      }, true);

      element.resizable({
        handles: 'e,w',
        containment: 'parent',
        minWidth: 20,
        stop: (event,ui) => {
          scope.$apply(() => {
            scope.vm.textBlock.position.y = Math.round(ui.position.top) + 4; // 4px border+text padding
            scope.vm.textBlock.position.x = Math.round(ui.position.left);
            scope.vm.textBlock.position.width = parseInt(ui.size.width);
          });
        }
      });

      element.draggable({
        handle: '.c-text-block__text',
        containment: 'parent',
        scroll: false,
        start: ((event, ui) => {
          ui.helper.bind('click.prevent', event => event.preventDefault())
        }),
        stop: (event,ui) => {
          scope.$apply(() => {
            scope.vm.textBlock.position.y = Math.round(ui.position.top) + 4; // 4px border+text padding
            scope.vm.textBlock.position.x = Math.round(ui.position.left);
          });
          setTimeout((() => ui.helper.unbind('click.prevent')), 300);
        }
      });

      element.bind('click', (event) => {
        scope.$apply(() => scope.vm.editing = true);
        event.stopPropagation();
      });

      element.bind('dblclick', (event) => {
        let bannerCreator = $(element).parents('.c-banner-creator');
        bannerCreator.find('#creatives-dynamictxt-btn').click();
        let index = _.sortBy(scope.vm.textBlocksCtrl.textBlocks, 'position.y').indexOf(scope.vm.textBlock);
        setTimeout(() => {
          bannerCreator.find('#line-'+index).focus();
        }, 500);
        scope.$apply(() => scope.vm.editing = true);
      });

      element.parents('body').bind('click', (event) => {
        if (!element[0].contains(event.target)) {
          scope.$apply(() => scope.vm.editing = false);
        }
      });
    }
  };
};

export default angular.module('app.components.campaigns.creatives_text_block', [])
  .directive('creativesTextBlocks', CreativesTextBlocksComponent)
  .directive('creativesTextBlock', CreativesTextBlockComponent)



/** WEBPACK FOOTER **
 ** ./src/components/creatives/creativesTextBlock.js
 **/